import React from "react";
import {
  FieldWrapper,
  FilterSelect,
  FilterToggle,
  FilterSortGroup,
} from "./jobsFilterUtils";

export const ROLES_SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "level", label: "Level" },
];

export function AdminRolesFilterFields({
  focusedFieldId,
  onFocusClear,
  levelFilterBy,
  setLevelFilterBy,
  showDeleted,
  setShowDeleted,
  sortKey,
  setSortKey,
  sortDir,
  setSortDir,
  availableRoleLevels = [],
}) {
  const levelOpts = [
    { value: "all", label: "All Levels" },
    ...availableRoleLevels.map((l) => ({ value: l, label: l })),
  ];

  return (
    <>
      <FieldWrapper
        fieldId="level"
        label="Level"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="admin-roles-level"
          value={levelFilterBy}
          onChange={setLevelFilterBy}
          options={levelOpts}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="showDeleted"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterToggle
          id="admin-roles-deleted"
          label="Show Deleted"
          checked={showDeleted}
          onChange={setShowDeleted}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="sort"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSortGroup
          id="admin-roles-sort"
          sortBy={sortKey}
          sortOrder={sortDir}
          onSortByChange={setSortKey}
          onSortOrderChange={setSortDir}
          sortOptions={ROLES_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildAdminRolesFilterChips({
  levelFilterBy,
  showDeleted,
  sortDir,
}) {
  const chips = [];
  if (levelFilterBy && levelFilterBy !== "all") {
    chips.push({
      id: "level",
      key: "levelFilterBy",
      fieldId: "level",
      label: `Level: ${levelFilterBy}`,
    });
  }

  if (showDeleted) {
    chips.push({
      id: "showDeleted",
      key: "showDeleted",
      fieldId: "showDeleted",
      label: "Show Deleted",
    });
  }

  if (sortDir !== "asc") {
    chips.push({
      id: "sortDir",
      key: "sortDir",
      fieldId: "sort",
      label: `Direction: ${sortDir === "asc" ? "Ascending" : "Descending"}`,
    });
  }

  return chips;
}
